import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { RequestPageParams } from '@shared/models';
import { CounterpartyService } from '@shared/services';
import { MessagesActions, selectRouteParams } from '@shared/store';
import { ErrorUtils } from '@shared/utils';

import { CounterpartyActions } from './counterparty.actions';

@Injectable()
export class CounterpartyEffects {
  constructor(
    private actions$: Actions,
    private counterpartyService: CounterpartyService,
    private store: Store,
  ) {}

  getCounterparty$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CounterpartyActions.loadCounterparties),
      concatLatestFrom(() => [this.store.select(selectRouteParams)]),
      mergeMap(([payload, routeParams]: [payload: { params: RequestPageParams }, routeParams: Params]) => {
        return this.counterpartyService.getCounterparty(payload.params, routeParams.id).pipe(
          map((response) =>
            CounterpartyActions.loadCounterpartySuccess({ counterparties: response.items, totalElements: response.totalElements }),
          ),
          catchError((error) => {
            return of(CounterpartyActions.loadCounterpartyError({ error }));
          }),
        );
      }),
    );
  });

  loadCounterpartyError$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CounterpartyActions.loadCounterpartyError),
      tap({
        next: (loadCounterpartyError) => {
          ErrorUtils.catchError('counterpartyService.getCounterparty error', loadCounterpartyError.error);
        },
      }),
      switchMap(() => of(MessagesActions.displayError({ message: 'Unable to fetch Counterparty.', title: 'Error' }))),
    );
  });
}
